module.exports = __webpack_public_path__ + "static/media/background-primary.3b4ee252.svg";